import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'numberOfKeys'
})
export class NumberOfKeysPipe implements PipeTransform {
  transform(value: any): any {
    return Object.keys(value).length;
  }
}
